import { useEffect } from 'react';
import { proxy } from 'valtio';

// Shared signal: a map tab is using left-click for its own selection, so the
// CG-670 left-click Attribute Info sidebar must defer. Ref-counted to survive
// route transitions that briefly overlap a tab unmount with the next tab's mount.
// Mirrors the measureStatus pattern.
export const mapClickOwnership = proxy({ count: 0 });

export const isMapClickOwnedByTab = () => mapClickOwnership.count > 0;

// Claim map-click ownership for the calling component's lifetime.
export function useOwnMapClicks() {
  useEffect(() => {
    mapClickOwnership.count += 1;
    return () => {
      mapClickOwnership.count -= 1;
    };
  }, []);
}
